module.exports = __webpack_public_path__ + "static/media/graphicdesign.51094a45.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Splash/images/graphicdesign.png
// module id = 1343
// module chunks = 0